import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=5d2566e4"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&id=5d2566e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports